import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getDeviceCardSize, getDeviceColor } from "../../../../store/blocks/devices/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _DeviceCard = function _DeviceCard(_ref) {
  var cardColor = _ref.cardColor,
    children = _ref.children,
    size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('device-card', "device-card--".concat(size)),
    style: {
      background: cardColor
    },
    "data-t-id": "components-DeviceCard"
  }, children);
};
_DeviceCard.propTypes = process.env.NODE_ENV !== "production" ? {
  cardColor: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    cardColor: getDeviceColor(state),
    size: getDeviceCardSize(state)
  };
};
export var DeviceCard = connect(mapStateToProps)(_DeviceCard);